<template>
  <div class="title">
    <div class="title-left">
      {{ pageTitlRoomName }}
    </div>
    <div class="title-right">
      <!-- 选中报警 选中不报警 报警不选中 不报警不选中 -->
      <div v-for="(item, index) in bedList" :key="index" class="container">
        <div
          class="item"
          :class="{
            'item-active-alarm': item.hasDefault && item.hasAlarm,
            'item-active': item.hasDefault && !item.hasAlarm,
            'item-hasAlarm': !item.hasDefault && item.hasAlarm,
          }"
          @click="clickBedItem(index)"
          @mouseenter="hoverBedItem(index)"
          @mouseleave="leaveBedItem"
        >
          <div class="bed-icon">
            <!-- 报警选中 -->
            <div v-if="item.hasAlarm && item.hasDefault">
			  <img
                class="bed"
                v-if="item.radarType == 3"
                src="./../../assets/icon_sos_btn_bell_6.png"
                alt=""
                srcset=""
				style="width: 32px; height: 24px; margin-top: -3px;"
              />
              <img
                class="bed"
                v-else-if="item.radarType == 1 && item.subStatus != 1"
                src="./../../assets/img/iconSleep_white@2x.png"
                alt=""
                srcset=""
              />
			  <img
                class="bed"
                v-else-if="item.radarType == 1 && item.subStatus == 1"
                src="./../../assets/img/iconLeaveBedWhite@2x.png"
                alt=""
                srcset=""
              />
              <img
                class="toilet"
                v-else
                src="./../../assets/img/iconToilet_white@2x.png"
                alt=""
                srcset=""
              />
            </div>
            <!-- 报警不选中 -->
            <div v-if="item.hasAlarm && !item.hasDefault">
				<img
					class="bed"
					v-if="item.radarType == 3"
					src="./../../assets/icon_sos_btn_bell_5.png"
					style="width: 32px; height: 24px; margin-top: -3px;"
				/>
              <img
                class="bed"
                v-else-if="item.radarType == 1 && item.subStatus != 1"
                src="./../../assets/img/iconSleep_Red@2x.png"
              />
			  <img
                class="bed"
                v-else-if="item.radarType == 1 && item.subStatus == 1"
                src="./../../assets/img/iconSleepAlarm_red@2x.png"
              />
              <img
                class="toilet"
                v-else
                src="./../../assets/img/iconToilet_red@2x.png"
              />
            </div>
            <!-- 不报警选中 -->
            <div v-if="!item.hasAlarm && item.hasDefault">
			  <img
                class="bed"
                v-if="item.radarType == 3"
                src="./../../assets/icon_sos_btn_bell_3.png"
                alt=""
                srcset=""
				style="width: 24px; height: 24px; margin-top: -3px;"
              />
              <img
                class="bed"
                v-else-if="item.radarType == 1 && item.subStatus != 1"
                src="./../../assets/img/iconSleep_white@2x.png"
                alt=""
                srcset=""
              />
			  <img
                class="bed"
                v-else-if="item.radarType == 1 && item.subStatus == 1"
                src="./../../assets/img/iconLeaveBedWhite@2x.png"
                alt=""
                srcset=""
              />
              <img
                class="toilet"
                v-else
                src="./../../assets/img/iconToilet_white@2x.png"
                alt=""
                srcset=""
              />
            </div>
            <!-- 不报警不选中 -->
            <div v-if="!item.hasAlarm && !item.hasDefault">
			  <img
                class="bed"
                v-if="item.radarType == 3"
                src="./../../assets/icon_sos_btn_bell_4.png"
                alt=""
                srcset=""
				style="width: 24px; height: 24px; margin-top: -3px;"
              />
              <img
                class="bed"
                v-else-if="item.radarType == 1 && item.subStatus != 1"
                src="./../../assets/img/iconSleep_blue@2x.png"
                alt=""
                srcset=""
              />
			  <img
                class="bed"
                v-else-if="item.radarType == 1 && item.subStatus == 1"
                src="./../../assets/img/iconSleep@2x.png"
                alt=""
                srcset=""
              />
              <img
                class="toilet"
                v-else
                src="./../../assets/img/iconToilet_blue@2x.png"
                alt=""
                srcset=""
              />
            </div>
          </div>
          <div class="bed-name" ref="bedName">{{ item.bedName }}</div>
          <div
            v-if="isShowBedName && nameIndex == index"
            :style="{ left: allNameLeft }"
            class="bed-name-all"
          >
            {{ bedNameAll }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { createGlobalStompScope } from '@/utils/stomp';

export default {
  props: {
    pageTitleData: {
      type: Array,
      default: () => {},
    },
    pageTitlRoomName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      allNameLeft: '0px',
      copyBedList: [],
      bedList: [],
      stompClientStatusRoom: null,
      bedNameAll: '',
      isShowBedName: false,
      nameIndex: 0,
    };
  },
  created() {
    console.log('pageTitlRoomName', this.pageTitlRoomName);
  },
  mounted() {
    this.bedList = this.pageTitleData;
    this.getSocketStatusRoom();
  },
  methods: {
    normalizeBoolean(value) {
      if (value === true || value === 1 || value === '1' || value === 'true') {
        return true;
      }
      if (value === false || value === 0 || value === '0' || value === 'false' || value === null || value === undefined || value === '') {
        return false;
      }
      return Boolean(value);
    },
    resolveHasAlarm(socketItem, currentHasAlarm) {
      if (socketItem && Object.prototype.hasOwnProperty.call(socketItem, 'hasAlarm')) {
        return this.normalizeBoolean(socketItem.hasAlarm);
      }
      if (socketItem && Object.prototype.hasOwnProperty.call(socketItem, 'outBedAlarm')) {
        return this.normalizeBoolean(socketItem.outBedAlarm);
      }
      return this.normalizeBoolean(currentHasAlarm);
    },
    getSocketStatusRoom() {
      let id = this.$route.query.roomId;
      if (this.stompClientStatusRoom) {
        this.stompClientStatusRoom.destroy();
        this.stompClientStatusRoom = null;
      }
        this.stompClientStatusRoom = createGlobalStompScope({
          vm: this,
          name: 'detail-title-room-status',
      });
      this.stompClientStatusRoom.subscribe('/topic/roomStatus.' + id, ({ body: socketData }) => {
        if (!socketData || !Array.isArray(socketData.bedList) || !Array.isArray(this.bedList)) {
          return;
        }
        const socketMap = {};
        socketData.bedList.forEach((item) => {
          if (item && item.bedId !== undefined && item.bedId !== null) {
            socketMap[item.bedId] = item;
          }
        });
        this.bedList.forEach((item) => {
          const socketItem = socketMap[item.bedId];
          if (!socketItem) {
            return;
          }
          item.hasAlarm = this.resolveHasAlarm(socketItem, item.hasAlarm);
          item.subStatus = socketItem.subStatus;
          item.status = socketItem.status;
          item.statusName = socketItem.statusName;
        });
      });
      this.stompClientStatusRoom.connect();
    },

    getRoomListById() {
      let params = {
        roomId: this.$route.query.roomId,
      };
      this.$get(
        '/api/v3/bed/getRoomListById',
        params,
        (res) => {
          if (res.code === 0) {
            if (!res.data) {
              return;
            }
            this.bedList = res.data.bedList;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    clickBedItem(data) {
      console.log(this.bedList[data], 'datadadadada s');
      this.$emit('changeDefaultBed', data);
      this.bedList.forEach((item) => {
        item.hasDefault = false;
      });
      this.bedList[data].hasDefault = true;
      this.copyBedList = this.$lodash.cloneDeep(this.bedList);
    },
    hoverBedItem(data) {
      this.copyBedList = this.$lodash.cloneDeep(this.bedList);
      this.bedList[data].hasDefault = true;
      this.allNameLeft = (data + 1) * 200 + 60 + 'px';
      if (this.$refs.bedName[data].clientWidth == 120) {
        this.nameIndex = data;
        this.bedNameAll = this.copyBedList[data].bedName;
        this.isShowBedName = true;
      }
    },
    leaveBedItem() {
      this.bedList = this.copyBedList;
      this.isShowBedName = false;
    },
  },
  beforeDestroy() {
    if (this.stompClientStatusRoom) {
      this.stompClientStatusRoom.destroy();
      this.stompClientStatusRoom = null;
    }
  },
};
</script>
<style lang="scss" scoped>
.title {
  width: 100%;
  height: 65px;
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 8px 8px 0 0;
  position: relative;
  .title-left {
    min-width: 120px;
    max-width: 160px;
    height: 65px;
    line-height: 65px;
    margin-right: 10px;
    background: #1890ff;
    color: #fff;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    border-radius: 8px 32px 32px 0px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    padding: 0 10px;
  }
  .title-right {
    width: 990px;
    overflow-x: auto;
    align-items: center;

    white-space: nowrap;
    .container {
      width: 190px;
      margin-left: 10px;
      display: inline-block;
    }
    .item {
      float: left;
      height: 45px;
      background: #e6f7ff;
      border-radius: 23px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 400;
      color: #1890ff;
      cursor: pointer;
      padding: 0 10px;
      .bed-icon {
        margin-right: 10px;
        .bed {
          width: 26px;
          height: 20px;
        }
        .toilet {
          width: 21;
          height: 25px;
        }
      }
      .bed-name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        max-width: 120px;
      }
      .bed-name-all {
        position: absolute;
        top: 40px;
        left: 60px;
        z-index: 999;
        width: 156px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 4px;
        border: 1px solid #1890ff;
        padding: 12px;
        color: #8c8c8c;
        font-size: 12px;
      }
    }
    .item-active {
      background: #1890ff;
      color: #fff;
    }
    .item-hasAlarm {
      background: #ffccc7;
      color: #ff4d4f;
    }
    .item-active-alarm {
      background: #ff4d4f;
      color: #fff;
    }
  }
}
</style>
